import { isEmpty } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';

import Rectangle from '../../../../../assets/img/Rectangle.svg';
import { AiDropdown } from '../../Styled';
import styles from './remark-category.module.scss';

const RemarkCategory = ({ selected, setSelected, options, placeholder, status, disabled }) => {
  const [isActive, setIsActive] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isActive && ref.current && !ref.current.contains(e.target)) {
        setIsActive(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isActive]);
  return (
    <div className={styles.dropdown} ref={ref}>
      <AiDropdown
        onKeyDown={() => {}}
        onClick={() => setIsActive(!isActive)}
        status={status}
        disabled={disabled}
      >
        <p className={styles.dropdownSelect__label} title={selected?.label || ''}>
          {selected?.label || (
            <span style={{ color: '#8D8D8D', fontSize: '14px' }}>{placeholder}</span>
          )}
        </p>
        <img src={Rectangle} alt="" width="10" height="10" />
      </AiDropdown>

      <div
        className={styles.dropdownContent}
        style={{ maxHeight: isActive && '260px', overflowY: isActive && 'auto' }}
      >
        {isActive &&
          !isEmpty(options) &&
          options.map((option) => {
            return (
              <div
                key={option?.value}
                onKeyDown={() => {}}
                onClick={() => {
                  setSelected(option);
                  setIsActive(false);
                }}
                className={styles.dropdownItem}
              >
                {option?.label}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default RemarkCategory;
